import { engineerRoles } from "src/generator/utils/mapUsers";
import { useSelector } from "src/redux/hooks";

/**
 * Temporary role gate for editing tank HH/H/L/LL limits.
 * Replace with a backend permission flag when available.
 */
export const useCanEditTankLimits = (): boolean => {
  const rolename = useSelector(state => state.permsSlice.rolename);
  const yachtAdmin = useSelector(state => state.permsSlice.yachtAdmin);
  const clientAdmin = useSelector(state => state.permsSlice.clientAdmin);

  if (yachtAdmin || clientAdmin) return true;
  return engineerRoles.includes((rolename ?? "").trim());
};
